<div class="table">
  <div class="table-row">
    <div class="table-cell">
      <strong>{{ 'API_VERSION' | translate }}</strong>
    </div>
    <div class="table-cell">{{ dataInfo?.version }}</div>
  </div>
  <div class="table-row">
    <div class="table-cell"><strong>{{ 'DATA_UPDATED' | translate }}</strong></div>
    <div class="table-cell">{{ dataInfo?.dataUpdated | date: 'dd.MM.yyyy' }}</div>
  </div>
</div>
